import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import router from './router'

const moment = require ('moment')

/*
let path = window.location.pathname;
let lang = 'en';
if (path.match(/^\/francais/i)) {
	lang = 'fr';
}
*/
let lang = process.env.VUE_APP_I18N_LOCALE;
require( 'moment/locale/' + lang + '-ca')

Vue.use(require('vue-moment'), { moment });

i18n.locale = lang;

Vue.config.productionTip = false

//Vue.use(require('vue-moment'));

Vue.prototype.$API_URL = process.env.VUE_APP_API_URL;

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
